import axios from 'axios';

const backendUrl = process.env.REACT_APP_BACKEND_URL;

const UTILISATEUR_URL = `${backendUrl}/api/utilisateur/`;
const AUTH_CHECK_URL = `${backendUrl}/api/auth/check/`;
const UTILISATEUR_LOGIN_URL = `${backendUrl}/api/auth/login/`;

class UtilisateurService {
	async checkAuthentication() {
		const token = localStorage.getItem('authToken');
		try {
			const response = await axios.get(AUTH_CHECK_URL, {
				headers: {
					Authorization: `Token ${token}`
				}
			});
			return response.status === 200; // Vérifiez si la réponse est OK
		} catch (error) {
			console.error('Error status:', error.response.status); // Print the status code
			console.error('Error data:', error.response.data); // Print the error data
			if (error.response && error.response.status === 401) {
				return false; // Si l'utilisateur n'est pas authentifié
			} else {
				console.error('Erreur de connexion', error);
				throw error; // Si une autre erreur s'est produite
			}
		}
	}

	async loginUser(usernameInput, passwordInput) {
		const response = await axios.post(UTILISATEUR_LOGIN_URL, {
			username: usernameInput,
			password: passwordInput
		});

		// Store token, name, and username if they are available
		const { token, name, username, role } = response.data;

		if (token) {
			localStorage.setItem('authToken', token);
			localStorage.setItem('userName', name);
			localStorage.setItem('userUsername', username);
			localStorage.setItem('userRole', role);
			axios.defaults.headers.common['Authorization'] = `Token ${token}`;
		} else {
			throw new Error('Token not found');
		}
	}

	logoutUser() {
		localStorage.removeItem('authToken');
		delete axios.defaults.headers.common['Authorization'];
	}

	async getAllUtilisateurs() {
		try {
			const response = await axios.get(UTILISATEUR_URL);
			const allUtilisateurs = response.data;

			// Filtrer les utilisateurs pour exclure ceux dont le rôle est "Default"
			return allUtilisateurs.filter((utilisateur) => utilisateur.role !== 6);
		} catch (error) {
			console.error('Erreur de connexion', error);
			throw error;
		}
	}

	getUtilisateur(id) {
		return axios.get(`${UTILISATEUR_URL}${id}/`);
	}

	getUserDetailsFromLocalStorage() {
		return {
			name: localStorage.getItem('userName'),
			username: localStorage.getItem('userUsername'),
			role: localStorage.getItem('userRole')
		};
	}

	createUtilisateur(data) {
		return axios.post(UTILISATEUR_URL, data).catch((error) => {
			console.error("Erreur lors de la création de l'utilisateur", error);
			throw error;
		});
	}

	updateUtilisateur(id, data) {
		return axios.put(`${UTILISATEUR_URL}${id}/`, data);
	}

	deleteUtilisateur(id) {
		return axios.delete(`${UTILISATEUR_URL}${id}/`);
	}

	getUtilisateurOptions() {
		return this.getAllUtilisateurs().then((utilisateurs) => {
			return utilisateurs.map((utilisateur) => ({
				value: utilisateur.id,
				label: (
					utilisateur.personnel.nom +
					' ' +
					utilisateur.personnel.prenom
				).toUpperCase()
			}));
		});
	}
}

export default new UtilisateurService();
